import ShoppingCart from '@mui/icons-material/ShoppingCart';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ShoppingCartIcon(props: FixMe) {
  return <ShoppingCart {...props} />;
}

export default ShoppingCartIcon;
